<template lang="pug">
  .make-an-entry-footer.mt-4
    .nudge.is-hidden-mobile.mr-3(
      v-if="type === 'journal'"
      :style="{ minHeight: `3px` }"
    )
      .nudge-text(
        v-show="showNudge"
        :style="{ position: `absolute` }"
      )
        span
          BIcon(
            :icon="stepsEntered() ? 'check-outline' : 'plus'"
            :type="stepsEntered() ? 'is-special-success' : 'is-info'"
          )
          span {{ stepsEntered() || stepsNudge }}
        span
          BIcon(
            :icon="photoEntered() ? 'check-outline' : 'plus'"
            :type="photoEntered() ? 'is-special-success' : 'is-info'"
          )
          span {{ photoEntered() || photoNudge }}
        span
          BIcon(
            :icon="noteEntered() ? 'check-outline' : 'plus'"
            :type="noteEntered() ? 'is-special-success' : 'is-info'"
          )
          span {{ noteEntered() || noteNudge }}
    .level.is-mobile
      .level-left
      .level-right
        .level-item
          WtButton(isText :isTextUnderlined="false" color="grey" size="small" @click.native="$emit('cancel')") CLOSE
        .level-item
          slot
</template>

<script>
import WtButton from "@@/WtButton/WtButton";

export default {
  name: "MakeAnEntryFooter",

  components: { WtButton },

  props: {
    formData: {
      type: FormData,
      required: true,
      validator: value => {
        return value instanceof FormData;
      }
    },

    entryItem: {
      type: Object,
      required: true
    },

    type: {
      type: String,
      default: "journal"
    }
  },

  data() {
    return {
      showNudge: false,
      stepsNudge: "Add Steps.",
      photoNudge: "Add a Photo.",
      noteNudge: "Add a Note."
    };
  },

  methods: {
    stepsEntered() {
      return this.formData.has("steps") || this.formData.has("activities")
        ? "Steps entered."
        : "";
    },

    photoEntered() {
      return this.formData.has("image") || this.entryItem.image
        ? "Photo entered."
        : "";
    },

    noteEntered() {
      return this.formData.has("text") || this.entryItem.text
        ? "Note entered."
        : "";
    }
  }
};
</script>

<style lang="sass"></style>
